import { MailIcon } from 'nexticons/outline';
import {
  ButtonUI,
  LayoutPartUI,
  ScrollableBoxUI,
  CircleCloseButtonUI,
  InputUI,
} from '@next-order/next-order-components';
import { useRef, useState } from 'react';
import { useSelector } from 'react-redux';

const RequestInvoice = ({ hideModal, orderId }) => {
  const { storeConfig } = useSelector((state) => state.layoutReducer);
  const [email, setEmail] = useState('');
  const [isValid, setIsValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const inputRef = useRef(null);

  const isValidEmail = (email) => {
    return /\S+@\S+\.\S+/.test(email);
  };

  const onChangeEmail = (e) => {
    const email = e.target.value;
    setEmail(email);
    if (email && isValidEmail(email)) {
      setIsValid(true);
    } else {
      setIsValid(false);
    }
  };

  const sendInvoice = () => {
    setIsLoading(true);
    setIsSuccess(false);
    setIsError(false);

    const requestObj = {
      orderId,
      sendSMS: false,
      sendEmail: true,
      sendEmailTo: 'customer',
      customerEmail: email,
    };

    fetch(`${storeConfig.cloudFunctionsUrl}/sendInvoice`, {
      method: 'post',
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ...requestObj,
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((result) => {
        if (result.success) {
          setIsSuccess(true);
          setIsLoading(false);
          setEmail('');
          setTimeout(() => {
            hideModal();
          }, 3000);
        } else {
          setIsError(true);
          setIsLoading(false);
          inputRef?.current?.focus();
        }
      })
      .catch(() => {
        inputRef?.current?.focus();
        setIsError(true);
        setIsLoading(false);
      });
  };

  return (
    <>
      <div className='w-full z-[999998] h-full bg-[#e1e1e1] opacity-75 absolute top-0 left-0' />
      <div className='dinein fixed z-[999999] bottom-0 w-full h-max flex justify-end'>
        <LayoutPartUI extendedClassName='overflow-hidden rounded-t-6.75 max-h-95.5 h-full w-full bg-white min-h-auto-container'>
          <LayoutPartUI.Header extendedClassName='pt-4.75 pb-5'>
            <LayoutPartUI.Row>
              <CircleCloseButtonUI
                size='2xl'
                extendedClassName='outline-0'
                onClick={hideModal}
              />
            </LayoutPartUI.Row>
          </LayoutPartUI.Header>
          <LayoutPartUI.Body paddingX='none'>
            <ScrollableBoxUI
              paddingX='lg'
              extendedClassName='pt-2 pb-5 -2xs:px-5'
            >
              <LayoutPartUI.Row extendedClassName='mb-11'>
                <h3 className='text-2xl 2xs:text-7.25 font-medium tracking-tight leading-tight'>
                  Send Tax Invoice
                </h3>
              </LayoutPartUI.Row>
              <LayoutPartUI.Row extendedClassName='relative'>
                <MailIcon
                  width={26}
                  className='absolute left-7.25 top-1/2 -translate-y-1/2 -translate-x-1/2 text-gray-500'
                />
                <InputUI
                  ref={inputRef}
                  autoFocus
                  name='table_number'
                  placeholder='Enter Email Address'
                  size='xl'
                  extendedClassName='`outline-0 focus:outline-0 shadow-cw pl-14.25'
                  value={email}
                  onChange={onChangeEmail}
                />
              </LayoutPartUI.Row>
              {isSuccess && (
                <LayoutPartUI.Row extendedClassName='flex items-center justify-center'>
                  <span className='text-green-600 text-3.125 font-semibold'>
                    Email Sent!
                  </span>
                </LayoutPartUI.Row>
              )}
              {isError && (
                <LayoutPartUI.Row extendedClassName='flex items-center justify-center'>
                  <span className='text-red-600 text-3.125 font-semibold'>
                    Unable to send an email!
                  </span>
                </LayoutPartUI.Row>
              )}
            </ScrollableBoxUI>
          </LayoutPartUI.Body>
          <LayoutPartUI.Footer
            extendedClassName='pt-5 pb-5.5 -2xs:px-5'
            paddingX='lg'
          >
            <ButtonUI
              fullWidth
              size='xl'
              rounded='xl'
              extendedClassName='2xs:min-h-12.25 2xs:text-lg outline-0'
              disabled={!isValid}
              isLoading={isLoading}
              onClick={sendInvoice}
            >
              Send Email
            </ButtonUI>
          </LayoutPartUI.Footer>
        </LayoutPartUI>
      </div>
    </>
  );
};

export default RequestInvoice;
